import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContextProvider } from '../../../store/page-context';
import { PageLink, PageTitle } from '../../../layout/core';
import { MerchantsListComponent } from '../../../components/merchants/MerchantPage/MerchantsListComponent';

export const MerchantsPage = (): JSX.Element => {
	const { t } = useTranslation();

	const merchantsBreadCrumbs: Array<PageLink> = [
		{
			title: t('MENU.ACCOUNTS'),
			path: '/accounts/accounts',
			isSeparator: false,
			isActive: false
		},
		{
			title: '',
			path: '',
			isSeparator: true,
			isActive: false
		}
	];
	return (
		<PageContextProvider page="accounts/merchants">
			<>
				<PageTitle breadcrumbs={merchantsBreadCrumbs}>{t('MERCHANT_PAGE.MERCHANTS_LIST')}</PageTitle>
				<MerchantsListComponent />
			</>
		</PageContextProvider>
	);
};
